import { build } from "../../../tools/ConfigBuilder";
import { lazy } from "react";

const billingPath = {
	path: "/profile/dispatcher-billing",
	component: lazy(() => import("./TripBillingPage")),
};

export default build([billingPath]);
